 <div *ngIf="see_more==false">
    <p style="display:inline;" *ngIf="cmt!=''" class="userPostText" innerHTML="{{ cmt | slice:0:130 | linkify}}"></p>
    <span  style="cursor:pointer; color:#ba0000" *ngIf="cmt.length>130" (click)="seeMore()"  >..{{mls.See_more}}</span>
</div>

<div  *ngIf="see_more==true">
    <p style="display:inline;" *ngIf="cmt!=''" class="userPostText" innerHTML="{{ cmt | linkify}}"></p>
    <span style="cursor:pointer; color:#8f4747" *ngIf="cmt.length>130" (click)="seeLess()"  >..{{mls.See_less}}</span>
</div> 
<!-- 
<div class="fulltextseecmmnt" id="fulltextseecmmnt{{id}}">
    <p class="userPostText" ><span innerHTML="{{ cmt | linkify}}"></span></p>            
</div>

<p id="seemoretextcmmnt{{id}}" class="text-left seemoretextcmmnt">
    <span  class="cursor-pointer text-medium-grey" (click)="seemoretextcmmnt()">...{{mls.See_more}}</span>
</p> -->